export interface NavItem {
  label: string;
  to: string;
  match: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: '首页', to: '/', match: '/' },
  { label: '电影', to: '/category/movie', match: '/category/movie' },
  { label: '电视剧', to: '/category/tv', match: '/category/tv' },
  { label: '资讯', to: '/#latest-news', match: '/#latest-news' },
  { label: '关于', to: '/about', match: '/about' },
];

export const GENRES = ['全部', '剧情', '悬疑', '科幻', '爱情', '犯罪', '古装', '都市', '家庭', '青春', '奇幻', '纪录'];

export const REGIONS = ['全部', '中国大陆', '中国香港', '美国', '日本', '韩国', '法国'];

export const YEARS = ['全部', '2025', '2024', '2023'];

export const SORT_OPTIONS = [
  { key: 'latest', label: '最新发布' },
  { key: 'hot', label: '热门推荐' },
  { key: 'rating', label: '评分最高' },
];

export const PAGE_SIZE = 8;

export const CATEGORY_META: Record<string, { title: string; desc: string }> = {
  movie: {
    title: '电影',
    desc: '汇聚院线新片、口碑佳作与经典重映，从商业大片到文艺小品，带你发现值得走进影院的每一部好电影。',
  },
  tv: {
    title: '电视剧',
    desc: '涵盖古装、悬疑、都市、科幻等多元题材，精选当下热播与高口碑剧集，陪你度过每一个追剧的夜晚。',
  },
};